import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const mobileScreenRoutes = ({
    Search,
    Create,
    Update,

}: {
    Search: React.ComponentType;
    Create: React.ComponentType;
    Update: React.ComponentType;
}) => (
    <Routes>
        <Route path={''} element={<Search />} />
        <Route path={ROUTES.PERMISSION.MOBILE_SCREEN.CREATE} element={<Create />} />
        <Route path={ROUTES.PERMISSION.MOBILE_SCREEN.EDIT} element={<Update />} />
    </Routes>
);
